import React from "react";
import { NextPage } from "next";

import RealEstateOffer from "scenes/RealEstateOffer";

const Index: NextPage = () => <RealEstateOffer />;

export default Index;
